var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.showBar)?_c('b-progress',{staticClass:"bar-container",attrs:{"value":_vm.value}}):_vm._e(),_c('LoadingSpinner'),_c('router-view',{on:{"loading-bar":_vm.handleLoadingBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }